import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=2df81a6a&scoped=true&"
import script from "./outbound.vue?vue&type=script&lang=js&"
export * from "./outbound.vue?vue&type=script&lang=js&"
import style0 from "./outbound.vue?vue&type=style&index=0&id=2df81a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df81a6a",
  null
  
)

export default component.exports